import * as c from '../constants/engineering';
import { gdlAction } from './api';
import { STATUS_ON, STATUS_OFF } from '../constants/common';
import _findKey from 'lodash/findKey';
import { announce } from './announcements';
import { getNodeTitle } from '../utils/engineering-utils';

export const initEngineering = (data) => ({
  type: c.ENG_INIT,
  data: data,
});

export const closeWorkArea = (node) => (dispatch, getState) => {
  const state = getState();
  const nodeId = state.engineering.nodes[node];
  const toolbar = state.engineering.toolbar;

  dispatch(
    gdlAction(
      [
        c.ENG_CLOSE_WORK_AREA,
        c.ENG_SEND_WORK_AREA_SUCCESS,
        c.ENG_SEND_WORK_AREA_FAILURE,
      ],
      (api) => api.closeWorkArea(nodeId),
      { node }
    )
  );

  // Announce work area closed to screen readers
  const nodeTitle = getNodeTitle(toolbar, node);
  if (nodeTitle) {
    dispatch(announce(`${nodeTitle} work area closed`));
  }
};

export const openWorkArea = (node) => (dispatch, getState) => {
  const state = getState();
  const nodeId = state.engineering.nodes[node];
  const toolbar = state.engineering.toolbar;

  dispatch(
    gdlAction(
      [
        c.ENG_OPEN_WORK_AREA,
        c.ENG_SEND_WORK_AREA_SUCCESS,
        c.ENG_SEND_WORK_AREA_FAILURE,
      ],
      (api) => api.openWorkArea(nodeId),
      { node }
    )
  );

  // Announce work area opened to screen readers
  const nodeTitle = getNodeTitle(toolbar, node);
  if (nodeTitle) {
    dispatch(announce(`${nodeTitle} work area opened`));
  }
};

export const resetWorkArea = (node) => (dispatch, getState) => {
  const nodeId = getState().engineering.nodes[node];

  dispatch(
    gdlAction(
      [
        c.ENG_SEND_WORK_AREA,
        c.ENG_SEND_WORK_AREA_SUCCESS,
        c.ENG_SEND_WORK_AREA_FAILURE,
      ],
      (api) => api.resetWorkArea(nodeId),
      { node }
    )
  );
};

export const applyWorkArea = (node, inputs) => (dispatch, getState) => {
  const nodeId = getState().engineering.nodes[node];

  dispatch(
    gdlAction(
      [
        c.ENG_SEND_WORK_AREA,
        c.ENG_SEND_WORK_AREA_SUCCESS,
        c.ENG_SEND_WORK_AREA_FAILURE,
      ],
      (api) => api.submitWorkArea(nodeId, inputs),
      { node }
    )
  );
};

export const updateWorkAreas = (workAreas) => ({
  type: c.ENG_UPDATE_WORK_AREAS,
  workAreas,
});

export const clearWorkAreas = () => ({
  type: c.ENG_CLEAR_WORK_AREAS,
});

export const updateSketcher = (params, node) => (dispatch, getState) => {
  let data = params;
  let nodeId;

  if (node) {
    nodeId = getState().engineering.nodes[node];
  }

  if (typeof params !== 'object') {
    // params is a query string, so we convert it to an object
    const sketcherParams = new URLSearchParams(params);
    data = {};
    for (let item of sketcherParams) {
      if (item[0] === 'node-id') {
        nodeId = item[1];
      } else {
        data[item[0]] = item[1];
      }
    }
  }

  if (!node && nodeId) {
    node = _findKey(getState().engineering.nodes, (item) => item === nodeId);
  }

  dispatch(
    gdlAction(
      [
        c.ENG_UPDATE_SKETCHER,
        c.ENG_UPDATE_SKETCHER_SUCCESS,
        c.ENG_UPDATE_SKETCHER_FAILURE,
      ],
      (api) => api.updateSketcher(nodeId, data),
      { node }
    )
  );
};

export const clearGraphics = () => (dispatch) => {
  dispatch(
    gdlAction(
      [
        c.ENG_CLEAR_GRAPHICS,
        c.ENG_CLEAR_GRAPHICS_SUCCESS,
        c.ENG_CLEAR_GRAPHICS_FAILURE,
      ],
      (api) => api.clearGraphics()
    )
  );
};

export const toggleGraphics = (node) => (dispatch, getState) => {
  const state = getState();
  const {
    nodes: { [node]: nodeId },
    graphics: { [node]: status },
    toolbar,
  } = state.engineering;

  const newStatus = status === STATUS_ON ? STATUS_OFF : STATUS_ON;

  dispatch(
    gdlAction(
      [
        c.ENG_TOGGLE_GRAPHICS,
        c.ENG_TOGGLE_GRAPHICS_SUCCESS,
        c.ENG_TOGGLE_GRAPHICS_FAILURE,
      ],
      (api) => api.toggleGraphics(nodeId),
      { node, status: newStatus }
    )
  );

  // Announce graphics toggle to screen readers
  const nodeTitle = getNodeTitle(toolbar, node);
  if (nodeTitle) {
    const action = newStatus === STATUS_ON ? 'displayed' : 'hidden';
    dispatch(announce(`${nodeTitle} ${action} in engineering scene`));
  }
};

export const syncGraphics = () => (dispatch) => {
  dispatch(
    gdlAction(
      [
        c.ENG_TOGGLE_GRAPHICS,
        c.ENG_TOGGLE_GRAPHICS_SUCCESS,
        c.ENG_TOGGLE_GRAPHICS_FAILURE,
      ],
      (api) => api.syncGraphics(),
      {}
    )
  );
};

export const setGraphicsStatus = (node, status) => ({
  type: c.ENG_SET_GRAPHICS_STATUS,
  node,
  status,
});

export const moveChart = (chartId, x, y) => ({
  type: c.ENG_MOVE_CHART,
  chartId,
  x,
  y,
});

export const bubbleChart = (chartId) => ({
  type: c.ENG_BUBBLE_CHART,
  chartId,
});

export const resizeChart = (chartId, size) => ({
  type: c.ENG_RESIZE_CHART,
  chartId,
  size,
});
